import React from 'react';
import { Form, Formik } from "formik";
import CustomInputField from './CustomInputField';
import { useDispatch } from 'react-redux';
import { hideModal } from '../redux/features/oxygen/customModalSlice';

const ClearPrecustomerDetails = ({data}) => {
    const {item} = data;
    const dispatch = useDispatch();

    const handleSubmit = async () => {
        
    }

  return (
    <div className="row">
        <div className="col-12">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex flex-column">
                        <div className="row mb-2">
                            <div className="col-md-12 col-sm-12">
                                Are you sure you want to clear {item?.fname} {item?.lname} ({item?.msisdn}) details?
                            </div>
                        </div>
                        <div className="form-group d-flex justify-content-between mt-4">
                            <button className="btn btn-secondary" onClick={() => dispatch(hideModal())}>
                                <b>Cancel</b>
                            </button>
                            <button
                                onClick={handleSubmit}
                                className="btn btn-primary btn-lg align-self-end"
                                // disabled={}
                            >
                                {"Clear"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ClearPrecustomerDetails;